import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import EquipmentGraphQL from '@graphql/equipment.queries';
import { Equipment } from '@models/equipment.model';

interface UseEquipmentReturn {
  equipments: Equipment[];
  loading: boolean;
  error: string | null;
  fetchEquipments: (taskId: string) => Promise<void>;
  setEquipments: (equipments: Equipment[]) => void;
}

export const useEquipment = (): UseEquipmentReturn => {
  const [equipments, setEquipments] = useState<Equipment[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEquipments = useCallback(async (taskId: string) => {
    if (!taskId) return;

    setLoading(true);
    setError(null);

    try {
      const data: any = await graphQlClient.request(
        EquipmentGraphQL.queries.getEquipments,
        { taskId },
      );

      const fetchedEquipments = data?.getEquipments || [];
      setEquipments(fetchedEquipments);
    } catch (err: any) {
      setError(
        err?.response?.errors?.[0]?.message || 'Failed to fetch equipment',
      );
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    equipments,
    loading,
    error,
    fetchEquipments,
    setEquipments,
  };
};
